import { useRootSelector } from "screens/Root/hooks/useAppSelector";
import Tab from "./Tab";
import TabTitle from "./TabTitle";
import { useDispatch } from "react-redux";
import { reorderTabs, setDockedTab, undockTab, } from "../slices/rootSlice";
import { getRootApi } from "meta/utils/getRootApi";
import { DragDropContext, Draggable, Droppable, } from "react-beautiful-dnd";
import { v4 as uuid } from "uuid";
import { useEffect, useState } from "react";
import { preventTransformX } from "meta/utils/preventTransformX";
import { LineColor } from "meta/utils/colors";
import { Box, withStyles } from "@material-ui/core";
import { closeContentTab } from "screens/Root/actions/contentTabActions";
import { notificationCenterUrl, pendingScreenUrl } from "screens/Root/utils/constants";
import { useNotifications } from "../NotificationIcons/useNotifications";
const List = withStyles({
    root: {
        padding: 0,
        margin: 0,
        listStyleType: "none",
        display: "flex",
        alignItems: "center",
    },
})(Box);
const PlaceholderContainer = withStyles({
    root: {
        "& > *": {
            boxShadow: "0 2px 0 0 " + LineColor + " inset",
            transform: "rotate(180deg)",
        },
    },
})(Box);
const maxDockedTabs = 3;
const DraggableTabs = ({ tabs, active, createClickHandler, createIdentification }) => {
    const [droppableId] = useState(uuid());
    const dispatch = useDispatch();
    const { dockedTabKeys } = useRootSelector();
    const { updateNotifications, loading } = useNotifications();
    const [refreshQueued, setRefreshQueued] = useState(false);
    useEffect(() => {
        if (refreshQueued && !loading) {
            const handleAsync = async () => {
                await updateNotifications();
                setRefreshQueued(false);
            };
            handleAsync();
        }
    }, [refreshQueued, loading]);
    const createDockClickHandler = (key) => (event) => {
        dispatch(setDockedTab(key));
        event.stopPropagation();
    };
    const createCloseClickHandler = (key) => (event) => {
        dispatch(closeContentTab(key));
        event.stopPropagation();
    };
    const createUndockClickHandler = (key) => (event) => {
        dispatch(undockTab(key));
        event.stopPropagation();
    };
    const refreshNotificationsClickHandler = async (event) => {
        if (refreshQueued) {
            return;
        }
        else if (loading) {
            setRefreshQueued(true);
        }
        else {
            await updateNotifications(true);
            event.stopPropagation();
        }
    };
    const refreshPendingClickHandler = async (event) => {
        getRootApi().FrontendEvents.webEvent({ type: "RX_REFRESH_PATIENTS" }, window.name);
        event.stopPropagation();
    };
    const handleDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
        if (result.destination.index === result.source.index) {
            return;
        }
        dispatch(reorderTabs({
            destination: result.destination.index,
            source: result.source.index,
            key: result.draggableId,
        }));
    };
    const activeKeyIndex = tabs.findIndex((x) => x[0] === active);
    return (<DragDropContext onDragEnd={handleDragEnd}>
      <Droppable direction="horizontal" droppableId={droppableId}>
        {({ droppableProps, innerRef, placeholder }) => (<List component="ul" data-identification="navigation-tabs-list" 
        // @ts-ignore
        ref={innerRef} {...droppableProps}>
            {tabs.map(([key, tab], index) => {
                const overrideStyle = (style) => {
                    style = preventTransformX(style);
                    return style;
                };
                const dockable = tab.dockable &&
                    !dockedTabKeys.includes(key) &&
                    dockedTabKeys.length < maxDockedTabs;
                const isActive = key === active;
                const isNotificationCenter = tab.url != null && tab.url.includes(notificationCenterUrl);
                const isPendingTab = tab.url != null && tab.url.includes(pendingScreenUrl);
                const renderTab = (draggableProps, dragHandleProps, innerRef) => (<Tab key={key} data-identification={createIdentification(tab)} data-active={isActive} data-menuId={tab.menuId} active={isActive} divider={index !== tabs.length - 1 &&
                        !isActive &&
                        index + 1 !== activeKeyIndex} onClick={createClickHandler(key)} dockable={dockable} isNotificationCenter={isNotificationCenter} isPendingTab={isPendingTab} onDockClick={createDockClickHandler(key)} undockable={dockedTabKeys.includes(key) && !tab.forceDocked} onUndockClick={createUndockClickHandler(key)} closeable={!tab.locked} onCloseClick={createCloseClickHandler(key)} onRefreshNotificationsClick={refreshNotificationsClickHandler} onRefreshPendingClick={refreshPendingClickHandler} notificationsRefreshing={loading} tabIndex={0} {...dragHandleProps} {...draggableProps} style={overrideStyle(draggableProps?.style)} innerRef={innerRef}>
                  <TabTitle tab={tab}/>
                </Tab>);
                return tab.locked ? (renderTab()) : (<Draggable key={key} draggableId={key} index={index} isDragDisabled={tab.locked}>
                  {({ draggableProps, dragHandleProps, innerRef }) => renderTab(draggableProps, dragHandleProps, innerRef)}
                </Draggable>);
            })}

            {placeholder ? (<PlaceholderContainer>{placeholder}</PlaceholderContainer>) : (placeholder)}
          </List>)}
      </Droppable>
    </DragDropContext>);
};
export default DraggableTabs;
